import React, { useState, useEffect, ChangeEvent, FormEvent } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "@/assets/css/style.css";
import "./AboutDetails.module.css";
import { useAppSelector } from "@/store/hooks";
import toast from "react-hot-toast";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AboutDetails: React.FC = () => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;

  const navigate = useNavigate();
  const { token } = useAppSelector((state) => state.auth);

  const [BannerImage, setBannerImage] = useState<File | string | null>(null);
  const [title, setTitle] = useState(""); // FIXED
  const [DirectorImage, setDirectorImage] = useState<File | string | null>(null);
  const [directorMessage, setDirectorMessage] = useState("");
  const [mission, setMission] = useState("");
  const [missionImage, setMissionImage] = useState<File | string | null>(null);
  const [vision, setVision] = useState("");
  const [visionImage, setVisionImage] = useState<File | string | null>(null);
  const [aboutUs, setAboutUs] = useState("");

  const [loading, setLoading] = useState(false);

  /** -------------------------------
   * LOAD EXISTING ABOUT DATA
   * -------------------------------*/
  useEffect(() => {
    fetch(`${baseUrl}/about-us`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-domain": window.location.hostname, // FIXED
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          setBannerImage(data.data.bannerImage || null);
          setTitle(data.data.title || "");
          setDirectorImage(data.data.directorImage || null);
          setDirectorMessage(data.data.directorMessage || "");
          setMission(data.data.mission || "");
          setMissionImage(data.data.missionImage || null);
          setVision(data.data.vision || "");
          setVisionImage(data.data.visionImage || null);
          setAboutUs(data.data.aboutFooter || "");
        }
      });
  }, [token]);

  /** -------------------------------
   * FILE CHANGE HANDLER (FIXED)
   * -------------------------------*/
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {

    console.log("e.target.name", e.target.name);
    const file = e.target.files?.[0];
    if (!file) return;

    const field = e.target.name;

    if (field === "bannerImage") setBannerImage(file);
    if (field === "directorImage") setDirectorImage(file);
    if (field === "missionImage") setMissionImage(file);
    if (field === "visionImage") setVisionImage(file);
  };

  /** -------------------------------
   * IMAGE PREVIEW
   * -------------------------------*/
  const getImageUrl = (image: File | string | null, fallback: string = "") => {
    return image instanceof File ? URL.createObjectURL(image) : image || fallback;
  };

  /** -------------------------------
   * SUBMIT FORM
   * -------------------------------*/
  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // if (BannerImage) 
      formData.append("bannerImage", BannerImage as Blob);
      // if (DirectorImage)
      formData.append("directorImage", DirectorImage as Blob);
      // if (missionImage)
      formData.append("missionImage", missionImage as Blob);
      // if (visionImage)
      formData.append("visionImage", visionImage as Blob);

      formData.append("title", title || "");
      formData.append("directorMessage", directorMessage || "");
      formData.append("mission", mission || "");
      formData.append("vision", vision || "");
      formData.append("aboutFooter", aboutUs || "");

      const res = await fetch(`${baseUrl}/about-us`, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = await res.json();

      if (data.success) {
        toast.success("About details updated!");
        navigate("/about-details", { state: { reload: true } });
      } else {
        toast.error(data.message || "Update failed");
      }
    } finally {
      setLoading(false);
    }
  };

  console.log("BannerImage", BannerImage);

  return (
    <div className="side-app">
      <div className="main-container container-fluid">
        <div className="page-header">
          <h1 className="page-title">Update About us Details</h1>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="/">Home</a></li>
            <li className="breadcrumb-item active">About us Details</li>
          </ol>
        </div>

        <div className="row">
          <div className="col-xl-12 col-md-12">
            <form className="card" onSubmit={handleSubmit}>
              <div className="card-body">

                {/* --------------------
                     BANNER IMAGE 
                ----------------------- */}
                <div className="row mb-5">
                  <label className="form-label">Banner</label>
                  <div className="col-lg-4 col-sm-12 mb-4 mb-lg-0">
                    <div
                      className="upload-box mb-4"
                      onClick={() => document.getElementById("bannerInput")?.click()}
                      style={{
                        border: "2px dashed #bbb",
                        borderRadius: "12px",
                        padding: "30px",
                        textAlign: "center",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        if (e.dataTransfer.files[0]) {
                          setBannerImage(e.dataTransfer.files[0]);
                        }
                      }}
                    >
                      <p className="fw-bold mb-1">Drag & Drop your image here</p>
                      <p className="text-muted mb-0">or click to browse</p>
                      <small className="d-block mt-2">
                        Recommended: 1280 × 720px (16:9)
                      </small>

                      <input
                        id="bannerInput"
                        name="bannerImage"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>

<div className="col-lg-4 col-sm-12">
  {BannerImage && (
    <>
      <img
        src={
          BannerImage instanceof File
            ? URL.createObjectURL(BannerImage)   // 👈 preview real file
            : getImageUrl(BannerImage, "")       // string from server
        }
        alt="Preview"
        style={{ height: 180, width: 300 }}
      />

      <button
        type="button"
        className="btn btn-sm btn-danger mt-3"
        onClick={() => setBannerImage(null)}
      >
        Remove
      </button>
    </>
  )}
</div>


                </div>

                {/* TITLE */}
                <div className="form-group">
                  <label className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>

                {/* --------------------
                     DIRECTOR IMAGE
                ----------------------- */}
                <div className="row mb-5">
                  <label className="form-label">Director Image</label>

                  <div className="col-lg-4 col-sm-12 mb-4">
                    <div
                      className="upload-box mb-4"
                      onClick={() => document.getElementById("directorInput")?.click()}
                      style={{
                        border: "2px dashed #bbb",
                        borderRadius: "12px",
                        padding: "30px",
                        textAlign: "center",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        if (e.dataTransfer.files[0]) {
                          setDirectorImage(e.dataTransfer.files[0]);
                        }
                      }}
                    >
                      <p className="fw-bold">Drag & Drop or Click</p>

                      <input
                        id="directorInput"
                        name="directorImage"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-12">
                    {DirectorImage && (
                      <>
                        <img
                          src={getImageUrl(DirectorImage, "")}
                          alt="Preview"
                          style={{ height: 180, width: 300 }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger mt-3"
                          onClick={() => setDirectorImage(null)}
                        >
                          Remove
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* DIRECTOR MESSAGE */}
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Director Message</h3>
                    </div>
                    <div className="card-body">
                      <CKEditor
                        editor={ClassicEditor}
                        data={directorMessage}
                        onChange={(_, editor) => setDirectorMessage((editor as any).getData())}
                      />
                    </div>
                  </div>
                </div>

                {/* MISSION */}
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Mission</h3>
                    </div>
                    <div className="card-body">
                      <CKEditor
                        editor={ClassicEditor}
                        data={mission}
                        onChange={(_, editor) => setMission((editor as any).getData())} />
                    </div>
                  </div>
                </div>


                {/* MISSION IMAGE */}
                <div className="row mb-5">
                  <label className="form-label">Mission Image</label>

                  <div className="col-lg-4 col-sm-12 mb-4">
                    <div
                      className="upload-box mb-4"
                      onClick={() => document.getElementById("missionInput")?.click()}
                      style={{
                        border: "2px dashed #bbb",
                        borderRadius: "12px",
                        padding: "30px",
                        textAlign: "center",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                      onDragOver={(e) => e.preventDefault()}
                      onDrop={(e) => {
                        e.preventDefault();
                        if (e.dataTransfer.files[0]) {
                          setMissionImage(e.dataTransfer.files[0]);
                        }
                      }}
                    >
                      <p className="fw-bold">Drag & Drop or Click</p>

                      <input
                        id="missionInput"
                        name="missionImage"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-12">
                    {missionImage && (
                      <>
                        <img
                          src={getImageUrl(missionImage, "")}
                          alt="Preview"
                          style={{ height: 180, width: 300 }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger mt-3"
                          onClick={() => setMissionImage(null)}
                        >
                          Remove
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* VISION */}
                <div className="col-12">
                  <div className="card">
                    <div className="card-header">
                      <h3 className="card-title">Vision</h3>
                    </div>
                    <div className="card-body">
                      <CKEditor
                        editor={ClassicEditor}
                        data={vision}
                        onChange={(_, editor) => setVision((editor as any).getData())}
                      />
                    </div>
                  </div>
                </div>

                {/* VISION IMAGE */}
                <div className="row mb-5">
                  <label className="form-label">Vision Image</label>

                  <div className="col-lg-4 col-sm-12 mb-4">
                    <div
                      className="upload-box mb-4"
                      onClick={() => document.getElementById("visionInput")?.click()}
                      style={{
                        border: "2px dashed #bbb",
                        borderRadius: "12px",
                        padding: "30px",
                        textAlign: "center",
                        cursor: "pointer",
                        background: "#fafafa",
                      }}
                    >
                      <p className="fw-bold">Drag & Drop or Click</p>

                      <input
                        id="visionInput"
                        name="visionImage"
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-12">
                    {visionImage && (
                      <>
                        <img
                          src={getImageUrl(visionImage, "")}
                          alt="Preview"
                          style={{ height: 180, width: 300 }}
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-danger mt-3"
                          onClick={() => setVisionImage(null)}
                        >
                          Remove
                        </button>
                      </>
                    )}
                  </div>
                </div>

                {/* ABOUT US FOOTER */}
                <div className="form-group">
                  <label className="form-label">
                    About Us (Short About Footer)
                  </label>
                  <textarea
                    className="form-control"
                    value={aboutUs}
                    onChange={(e) => setAboutUs(e.target.value)}
                  />
                </div>

                {/* SUBMIT BUTTON */}
                <button
                  type="submit"
                  name="about_details"
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Updating..." : "Update"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutDetails;

